import { getVar } from "./vars.js";

export const userinfo = () => getVar("userinfo") || {};
